type QuotedProduct = {
    monthlyAmount: number
}

export function sortQuotedProductByPrice<T extends QuotedProduct>(a: T, b: T) {
    return a.monthlyAmount - b.monthlyAmount
}
